import { Button, Flex, Heading, Input, Text } from "@chakra-ui/react";
import { memo, useCallback, useState } from "react";

import { ProductDetails } from "helpers/fakeData";
import SizePicker from "@features/marketplace/catalog/SizePicker";
import ColorPicker from "@features/marketplace/catalog/ColorPicker";
import { useStores } from "stores/rootStore";
import { toaster } from "@components/ui/toaster";

interface Props {
  product: ProductDetails;
  onSelectColor?: (color: string) => void;
  onAddToCart?: (product: ProductDetails) => void;
}

const ProductDescription = ({ product, onAddToCart, onSelectColor }: Props) => {
  const { marketPlaceStore } = useStores();
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState<string | undefined>(
    undefined
  );
  const [selectedColor, setSelectedColor] = useState<string | undefined>(
    undefined
  );

  const handleSelectSize = useCallback((size: string) => {
    setSelectedSize(size);
  }, []);

  const handleSelectColor = useCallback((color: string) => {
    setSelectedColor(color);
    onSelectColor?.(color);
  }, []);

  const addToCart = useCallback(() => {
    marketPlaceStore.addToCart({
      productId: product.id,
      size: selectedSize,
      color: selectedColor,
      quantity,
    });
    toaster.create({
      title: product.title,
      description: `Added to cart`,
      type: "success",
    });
    onAddToCart?.(product);
  }, [
    marketPlaceStore,
    product.id,
    selectedColor,
    selectedSize,
    quantity,
    onAddToCart,
  ]);

  return (
    <Flex flexDirection="column" gap={10} maxW="md">
      <Text fontWeight="normal">{product.description}</Text>
      <Heading size="2xl">{`${product.currency}${product.price}`}</Heading>
      <ColorPicker product={product} onSelectColor={handleSelectColor} />
      <SizePicker product={product} onSelectSize={handleSelectSize} />
      <Flex flexDirection="row" gap={2}>
        <Input
          borderColor="border.light"
          type="number"
          min={1}
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
          w="60px"
        />
        <Button size="sm" variant="solid" onClick={addToCart}>
          Add to cart
        </Button>
      </Flex>
    </Flex>
  );
};

export default memo(ProductDescription);
